import gsap from '../../../gsap-public/esm/index.js';
import ScrollTrigger from '../../../gsap-public/esm/ScrollTrigger.js';

const log = (message, ...args) => {
  const timestamp = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit', fractionalSecondDigits: 3 });
  console.log(`[${timestamp}] 📜 ScrollAnimations: ${message}`, ...args);
};

class ScrollAnimations {
  constructor() {
    log('Constructor called');
    this.init();
  }

  init() {
    log('Initializing scroll animations...');

    // Wait for next frame to ensure DOM is fully laid out before creating triggers
    requestAnimationFrame(() => {
      this.animateSectionTitles();
      log('Section titles animated');
      this.animateScrollReveal();
      log('Scroll reveal setup');
      this.animatePortfolioCards();
      log('Portfolio cards animated');
      this.animateServiceCards();
      log('Service cards animated');
      // DISABLED - Causes hero text to disappear on scroll
      // this.animateHeroOnScroll();
      log('Hero scroll animation DISABLED to keep text visible');

      // Refresh ScrollTrigger after all animations are set up
      // Use a short delay to ensure Lenis has settled
      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
        log('ScrollTrigger refreshed');
      });
    });
  }

  animateSectionTitles() {
    const titles = document.querySelectorAll('.section-title');

    titles.forEach(title => {
      const line = title.querySelector('.section-title__line');
      if (!line) return;

      gsap.from(line, {
        xPercent: -100,
        opacity: 0,
        duration: 1.5,
        ease: 'power4.out',
        scrollTrigger: {
          trigger: title,
          start: 'top 80%',
          end: 'top 40%',
          scrub: 1
        }
      });
    });
  }

  animateScrollReveal() {
    const elements = document.querySelectorAll('[data-scroll-reveal]');

    elements.forEach((el) => {
      gsap.from(el, {
        opacity: 0,
        y: 60,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          toggleActions: 'play none none reverse'
        }
      });
    });
  }

  animatePortfolioCards() {
    const cards = document.querySelectorAll('.portfolio-card');

    cards.forEach((card) => {
      const image = card.querySelector('.portfolio-card__image img, .portfolio-card__image-placeholder');
      const content = card.querySelector('.portfolio-card__content');

      if (!image) return;

      // Image parallax — scrub-linked
      gsap.from(image, {
        scale: 1.15,
        y: -20,
        ease: 'none',
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          end: 'top 30%',
          scrub: 1
        }
      });

      // Content fade — play once, not scrub-linked
      if (content) {
        gsap.from(content, {
          opacity: 0,
          y: 20,
          duration: 0.7,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: card,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        });
      }
    });
  }

  animateServiceCards() {
    // Service cards are static — no scroll animation
  }

  animateHeroOnScroll() {
    const heroContent = document.querySelector('.hero__content');
    if (!heroContent) return;

    // Gentle fade out hero as we scroll (less aggressive)
    gsap.to(heroContent, {
      opacity: 0.3,
      y: -50,
      scrollTrigger: {
        trigger: '.hero',
        start: 'top top',
        end: '80% top',
        scrub: true
      }
    });
  }
}

export default ScrollAnimations;
